import * as React from "react";
import {DialogEx} from "@/lib/components/DialogEx";
import {ButtonEx} from "@/lib/components/buttons/ButtonEx";
import {useTranslation} from "react-i18next";
import {companyApi} from "@/boxhub-api";
import {AdminI18N, CommonI18N} from "@/translations";
import {useSnackbarEx} from "@/lib/snackbarex";
import {useNavigate} from "react-router-dom";
import {AppPaths} from "@/app/AppPaths";

export type DeleteCompanyDialogProps = {
    open: boolean;
    close: () => void;
    companyId: number;
    companyName: string;
};

export const DeleteCompanyDialog = ({ open, close, companyId, companyName }: DeleteCompanyDialogProps) => {
    const { t } = useTranslation();
    const { showMessage } = useSnackbarEx();
    const navigate = useNavigate();

    const handleDelete = () => {
        companyApi
            .deleteCompany(companyId)
            .then(() => {
                showMessage({
                    summary: t(AdminI18N.companies.message.deleteSuccess),
                    severity: "success"
                });
                close();
                navigate(AppPaths.COMPANY_OVERVIEW, { replace: true });
            })
            .catch((error) => {
                showMessage({
                    summary: t(AdminI18N.companies.message.deleteFailed),
                    error,
                    severity: "error"
                });
                close();
            });
    };

    const buttons = (
        <>
            <ButtonEx label={t(CommonI18N.action.cancel)} onClick={close} color="secondary"/>
            <ButtonEx label={t(AdminI18N.companies.action.confirmDelete)} onClick={handleDelete} color="error"/>
        </>
    );

    return (
        <DialogEx
            open={open}
            onClose={close}
            title={t(AdminI18N.companies.dialog.deleteTitle, {companyName})}
            buttons={buttons}
            maxWidth="xs"
            fullWidth
        >
            <p>{t(AdminI18N.companies.dialog.deleteMessage, {companyName})}</p>
        </DialogEx>
    );
};
